import React from 'react'
import { DefaultMarkdown } from '@jelly/templates'

const BndDefaultMarkdown = (props) => {
	return <DefaultMarkdown {...props} />
}

export default BndDefaultMarkdown
